import { z } from 'zod';

export const MonitorIdSchema = z.string().brand('MonitorId');

export type MonitorId = z.infer<typeof MonitorIdSchema> | string;